export default __webpack_public_path__ + "static/media/010-barrel.9079677f.png";